export default __webpack_public_path__ + "static/media/scheduleit_desktop.33af0ea7.jpg";